




import { treeSelectedHeliocleanSitesActions } from './actions';
import { treeSelectionHeliocleanSiteMutations } from './mutations';
import { treeSelectedHeliocleanSitesGetters } from './getters';

const state = {
    treeSelectedHeliocleanSitesFleet: []
};
const actions = { ...treeSelectedHeliocleanSitesActions };
const mutations = { ...treeSelectionHeliocleanSiteMutations };
const getters = { ...treeSelectedHeliocleanSitesGetters };


// eslint-disable-next-line import/prefer-default-export
export const treeSelectedHeliocleanSitesStore = {
    namespaced: true,
    state, actions, mutations, getters,
};
